import React, { useState, useEffect } from 'react';
import './DownloadFileModal.css';

interface DownloadFileModalProps {
    isOpen: boolean;
    onClose: () => void;
    onDownload: (filename: string) => void;
    placeholderFilename: string;
}

const DownloadFileModal: React.FC<DownloadFileModalProps> = ({
    isOpen,
    onClose,
    onDownload,
    placeholderFilename
}) => {
    const [filename, setFilename] = useState('');

    useEffect(() => {
        if (isOpen) {
            // Add keyboard event handlers
            const handleKeyDown = (e: KeyboardEvent) => {
                if (e.key === 'Escape') {
                    onClose();
                } else if (e.key === 'Enter') {
                    handleDownload();
                }
            };

            document.addEventListener('keydown', handleKeyDown);
            return () => document.removeEventListener('keydown', handleKeyDown);
        }
    }, [isOpen, onClose]);

    // Reset filename when modal closes
    useEffect(() => {
        if (!isOpen) {
            setFilename('');
        }
    }, [isOpen]);

    const handleDownload = () => {
        onDownload(filename || placeholderFilename);
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="download-modal-content download-modal" onClick={(e) => e.stopPropagation()}>
                <h2>Download Vehicle Log</h2>
                <p>Enter a filename for your download</p>

                <div className="filename-input-container">
                    <input
                        type="text"
                        value={filename}
                        onChange={(e) => setFilename(e.target.value)}
                        placeholder={placeholderFilename}
                        className="filename-input"
                        autoFocus
                    />
                </div>

                <div className="button-group">
                    <button className="submit-button" onClick={handleDownload}>
                        Download
                    </button>
                    <button className="cancel-button" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DownloadFileModal; 